import { render } from "./YourDetailsSV1.vue?vue&type=template&id=5364ec06&scoped=true"
import script from "./YourDetailsSV1.vue?vue&type=script&lang=js"
export * from "./YourDetailsSV1.vue?vue&type=script&lang=js"

import "./YourDetailsSV1.vue?vue&type=style&index=0&id=5364ec06&lang=scss"
import "./YourDetailsSV1.vue?vue&type=style&index=1&id=5364ec06&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4153154969/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5364ec06"]])

export default __exports__